import React, { useCallback, useState } from 'react';
import { Box, Button, Flex, Link, Text } from '@chakra-ui/react';
import SimpleInput from 'components/SimpleInput';

type Props = {
  isLoading: boolean;
  errorMessage?: string;
  onSubmit: (code: string) => void;
  onBack: () => void;
};

const MfaVerify: React.FC<Props> = ({
  isLoading,
  errorMessage,
  onSubmit,
  onBack,
}) => {
  const [code, setCode] = useState('');

  const handleChange = useCallback(
    (value: string) => {
      const digits = value.replace(/\D/g, '').slice(0, 6);
      setCode(digits);
      if (digits.length === 6) {
        onSubmit(digits);
      }
    },
    [onSubmit],
  );

  return (
    <Box>
      <Text mb="32px" fontWeight="500" fontSize="22px" color="black">
        Verificação em dois fatores
      </Text>
      <Text fontSize="sm" color="text.300" mb="18px">
        Digite o código de 6 dígitos do seu aplicativo autenticador.
      </Text>

      <SimpleInput
        id="mfaCode"
        data-cy="mfa-code"
        bg="transparent"
        mb="18px"
        placeholder="000000"
        value={code}
        onChange={event => handleChange(event.target.value)}
        type="text"
        error={errorMessage}
      />

      <Button w="100%" type="button" isLoading={isLoading} onClick={() => onSubmit(code)}>
        Verificar
      </Button>

      <Flex mt="18px" justifyContent="center">
        <Link as="button" type="button" fontSize="sm" color="ocean.200" onClick={onBack}>
          Voltar ao login
        </Link>
      </Flex>
    </Box>
  );
};

export default MfaVerify;
